import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { IDetails_Response } from '@shared/constants/models.const';
import { ViewletTabComponent } from '@shared/components/viewlet/components/viewlet-tab/viewlet-tab.component';
import { E_VIEWLET_TYPE, TABS_SETTINGS } from './viewlet.const';
import { TranslateModule } from '@ngx-translate/core';
import { FilterProjPipe } from '@shared/components/viewlet/pipes/filter-proj.pipe';

@Component({
  selector: 'app-viewlet',
  imports: [
    MatTabGroup,
    MatTab,
    ViewletTabComponent,
    TranslateModule,
    FilterProjPipe,
  ],
  templateUrl: './viewlet.component.html',
  styleUrl: './viewlet.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewletComponent {
  E_VIEWLET_TYPE = E_VIEWLET_TYPE;
  TABS_SETTINGS = TABS_SETTINGS;
  pageData = input<IDetails_Response | any>();
}
